export default __webpack_public_path__ + "static/media/stuardess.ec347251.mp3";